module.exports = __webpack_public_path__ + "img/female-solid1.5263c812.svg";